import script from "./MarketplaceView.vue?vue&type=script&setup=true&lang=js"
export * from "./MarketplaceView.vue?vue&type=script&setup=true&lang=js"

import "./MarketplaceView.vue?vue&type=style&index=0&id=84a329b0&lang=scss"
import "./MarketplaceView.vue?vue&type=style&index=1&id=84a329b0&scoped=true&lang=scss"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-84a329b0"]])

export default __exports__